<template>
  <div v-if="banner" class="banner bg-blue">
    <div class="container">
      <div class="banner-content" @click="handleBannerClick" :class="{ clickable: banner.url }">
        <span class="banner-text white-color font-186 font-bold">{{ banner.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BannerComponent",
    props: {
      banner: {
        type: Object,
        default: null,
      },
    },
    methods: {
      handleBannerClick() {
        if (this.banner && this.banner.url) {
          window.open(this.banner.url, "_blank");
        }
      },
    },
  };
</script>

<style scoped>
  .banner-content.clickable {
    cursor: pointer;
  }

  @media (max-width: 767px) {
    .banner {
      position: fixed;
      width: 100%;
    }
  }
</style>
